/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import {
  Col,
  Row,
  Select,
  Dropdown,
  Checkbox,
  Input,
  DatePicker,
  Table,
  Menu,
  Button,
  Modal,
  Form,
} from "antd";

// Components
import MultiSelect from "../../../components/common/MultiSelect";
import RightBar from "../../../components/common/RightBar";

// data
import {
  venderList,
  propertyUnits,
  statusList,
  assignedToList,
  WorkOrdersRightBar,
  tableAllData,
  sortByList,
} from "./WordOrdersData";

// styles
import "./workOrders.css";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  QuerySnapshot,
  where,
  updateDoc,
  setDoc,
} from "@firebase/firestore";
import { auth, db } from "../../../firebase";
import TextArea from "antd/es/input/TextArea";
import { Propertiesunitscampaigns } from "../../../data/rentalapplications";
import { toast } from "react-hot-toast";

//method for savedFilterMenu
function getItem(label, key, children, type) {
  return {
    key,
    label,
    children,
    type,
  };
}

function WorkOrders() {
  const [isShowAdvancedFilters, setIsShowAdvancedFilters] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [properties, setProperties] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [workOrders, setWorkOrders] = useState([]);
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [filteredData, setFilteredData] = useState(workOrders);
  const [isSortByAsc, setIsSortByAsc] = useState(false);
  const [count, setCount] = useState(0);
  const [countNotes, setCountNotes] = useState(0);
  const [editDescription, setEditDescription] = useState(false);
  const [editedDescription, setEditedDescription] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [filtersData, setFiltersData] = useState({
    searchByPropertiesUnits: "",
    filterByStatus: "",
    filterByAssignedTo: "",
    filterByVendor: "",
    filterByUnassigned: false,
    searchByResident: "",
    searchByDescription: "",
    searchByVendorTrade: "",
    dateRangeFor: "",
    dateRangeStart: "",
    dateRangeEnd: "",
    filterByBilled: "",
    filterByPriority: "",
    searchByLastAction: "",
    searchByWorkOrderNumber: "",
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleEmail, setIsModalVisibleEmail] = useState(false);
  const [isModalVisibleCancel, setIsModalVisibleCancel] = useState(false);

  const handleButtonClick = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleButtonClickEmail = () => {
    setIsModalVisibleEmail(true);
  };

  const handleModalCloseEmail = () => {
    setIsModalVisibleEmail(false);
  };
  const handleButtonClickCancel = () => {
    setIsModalVisibleCancel(true);
  };

  const handleModalCloseCancel = () => {
    setIsModalVisibleCancel(false);
  };

  const navigate = useNavigate();

  const handleNewServiceRequest = () => {
    navigate("/maintenance/work-orders/service-requests/new");
  };

  const [filters, setFilters] = useState({});
  const [filteredWorkOrders, setFilteredWorkOrders] = useState(workOrders);
  console.log("Work orders", filteredWorkOrders)
  console.log("Work orders****************&&&&&&&&&&&", workOrders)

  // const handleChangeInputs = (item) => {
  //   setFiltersData((filtersData) => ({
  //     ...filtersData,
  //     [item.name]: item.value,
  //   }));
  // };

  console.log("***************",properties)
  const handleChangeInputs = ({ name, value }) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleSearchDescription = (e) => {
    console.log(e.target.value);
    setFiltersData((filtersData) => ({
      ...filtersData,
      searchByDescription: e.target.value,
    }));
  };

  const handleSearchByAction = (e) => {
    console.log(e.target.value);
    setFiltersData((filtersData) => ({
      ...filtersData,
      searchByLastAction: e.target.value,
    }));
  };

  function handleAdvancedFilters() {
    setIsShowAdvancedFilters(!isShowAdvancedFilters);
  }

  function handleResetInputs() {
    setFiltersData({
      searchByPropertiesUnits: "",
      filterByStatus: statusList[1],
      filterByAssignedTo: "",
      filterByVendor: "",
      filterByUnassigned: "",
      filterByWorkOrderType: "",
      searchByResident: "",
      searchByDescription: "",
      searchByVendorTrade: "",
      dateRangeFor: "",
      dateRangeStart: "",
      dateRangeEnd: "",
      filterByBilled: "",
      filterByPriority: "",
      searchByLastAction: "",
      searchByWorkOrderNumber: "",
    });
  }

  const items = [
    {
      label: <a onClick={() => alert("Complete ")}>Complete</a>,
      key: "0",
    },
    {
      label: <a onClick={() => alert("Assign ")}>Assign</a>,
      key: "1",
    },
    {
      label: <a onClick={() => alert("Cancel ")}>Cancel</a>,
      key: "2",
    },
  ];

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [checked, setChecked] = useState(false);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;
  console.log(selectedRowKeys.length);

  const saveEditDescription = () => {
    setEditDescription(false);
  };

  const handleSavedFilter = (e) => {
    console.log("click ", e);
  };
  const handleSortBy = (value) => {
    console.log(`selected ${value}`);
  };

  const [expended, setExpended] = useState();

  const expend = (e, index) => {
    e.stopPropagation();
    if (expended === index) setExpended(undefined);
    else setExpended(index);
  };
  const handleSaveDescription = (record, description) => {
    // Perform the necessary operations to save the edited description
    // to your desired destination, such as a backend or database.
    // You can use your preferred method, such as making an API call or
    // using a library like Firebase.

    console.log("Saving description:", record.id, description);
  };

  const handleSaveButtonClick = (record) => {
    // Call the function to save the edited description
    // handleSaveDescription(record, editedDescription);

    // Disable the edit mode and clear the edited description
    handleSaveDescription(record, editedDescription);

    setEditDescription(false);
    setEditedDescription("");
  };

  const tableTopHeader = [
    {
      title: (
        <div style={{ float: "left" }}>
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            className="workOrderSavedFilters"
          >
            <a onClick={(e) => e.preventDefault()}>
              Bulk Actions
              <DownOutlined />
            </a>
          </Dropdown>
          <span style={{ fontWeight: "100" }}>
            {" "}
            {selectedRowKeys.length} Selected
          </span>
        </div>
      ),
      children: [
        {
          dataIndex: "serviceRequest",
          width: 150,
        },
        {
          dataIndex: "Property",
          width: 250,
        },
        {
          dataIndex: "description",
          width: 300,
        },
      ],
    },
    {
      title: (
        <div style={{ float: "right" }}>
          <label htmlFor="sortby">Sort By </label>
          <Select
            defaultValue="CreatedAt"
            style={{
              width: 120,
            }}
            onChange={handleSortBy}
            options={sortByList}
          />
          <DownOutlined />
        </div>
      ),
      children: [
        {
          dataIndex: "venderAndAssign",
          width: "auto",
        },
        {
          dataIndex: "createdAt",
          width: "auto",
        },
        {
          key: "operation",
          render: (_, _1, index) => {
            return (
              <a className="onclick-text" onClick={(e) => expend(e, index)}>
                {index === expended ? <UpOutlined /> : <DownOutlined />}
              </a>
            );
          },
          width: "auto",
        },
      ],
    },
  ];

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const propertiesRef = collection(companyDocRef, "properties");
        const querySnapshot = await getDocs(propertiesRef);

        const fetchedData = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: doc?.data()?.propertyNameAddress?.propertyName,
          label: doc?.data()?.propertyNameAddress?.propertyName,
        }));
        console.log("object:::::::::::::",fetchedData)
        setProperties(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    setIsLoading(true)
    if (!isCompanyNameFetched) return;
    const fetchVendors = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const vendorsRef = collection(companyDocRef, "vendors");
        const querySnapshot = await getDocs(vendorsRef);

        console.log("...", querySnapshot);

        const fetchedVendors = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: `${doc?.data()?.vendorInfo?.firstName} ${
            doc?.data()?.vendorInfo?.lastName
          }`,
          label: `${doc?.data()?.vendorInfo?.firstName} ${
            doc?.data()?.vendorInfo?.lastName
          }`,
          vendorContact: doc?.data()?.contact?.phoneNumbers[0]?.phoneNumber,
          vendorEmail: doc?.data()?.contact?.emails[0]?.email,
        }));

        setVendors(fetchedVendors);
        console.log(fetchedVendors, "fetching vendor");
      } catch (err) {
        console.error(err);
        alert(err.message);
      } finally{
    setIsLoading(false)

      }
    };
    console.log("useeffect");

    fetchVendors();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched]);

  const propertyArr = [];
  properties?.forEach((element) => {
    propertyArr.push(element.value);
    console.log(element, "element");
  });
  const vendorArr = [];
  vendors?.forEach((element) => {
    vendorArr.push(element.value);
    console.log(element, "element");
  });
  const fetchWorkOrders = async () => {
    const workOrderRef = collection(
      db,
      "companies",
      companyName,
      "workOrders"
    );
    const propertiesRef = collection(
      db,
      "companies",
      companyName,
      "properties"
    );
    const vendorRef = collection(db, "companies", companyName, "vendors");
    const snapShotData = await getDocs(propertiesRef);
    const fetchedProperties = snapShotData.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    const snapShotDataVendor = await getDocs(vendorRef);
    const fetchedVendors = snapShotDataVendor.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    try {
      const snapShot = await getDocs(workOrderRef);
      const fetchedData = snapShot.docs.map((doc) => {
        const workOrderId = doc.id;
        const workOrderData = doc.data();
        console.log("workOrders,,,,,,", workOrderData)

        const matchingProperty = fetchedProperties.find(
          (property) => property.id === workOrderData?.ownerInformation?.propertyId
        );

        const matchingVendor = fetchedVendors.find(
          (vendor) => vendor.id === workOrderData.workOrderInformation.vendorId
        );

        if (matchingProperty || matchingVendor) {
          const propertyName = `${matchingProperty?.propertyNameAddress.propertyName}`;
          const propertyAddress = `${matchingProperty?.propertyNameAddress.propertyAddressOne}, ${matchingProperty?.propertyNameAddress.city}, ${matchingProperty?.propertyNameAddress.state} ${matchingProperty?.propertyNameAddress.zipCode}`;
          const propertyManager = `${matchingProperty?.propertyInformation.managerFirstName} ${matchingProperty?.propertyInformation.managerLastName}`;
          const vendorName = `${matchingVendor?.vendorInfo.firstName}`;
          return {
            id: workOrderId,
            key: workOrderId,
            vendorName: vendorName,
            ...workOrderData,
            propertyName: propertyName,
            propertyAddress: propertyAddress,
            propertyManager: propertyManager,
          };
        }
      });
      setWorkOrders(fetchedData);
      console.log("fetchedDatafetchedData", fetchedData);
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    fetchWorkOrders();
  }, [companyName, isCompanyNameFetched]);

  console.log("workOrderworkOrderworkOrderworkOrder",workOrders)
  useEffect(() => {
    const filteredData = workOrders.filter((order) => {
      // Filter by Property or Units
      if (
        filters.searchByPropertiesUnits &&
        order.ownerInformation.propertyId !== filters.searchByPropertiesUnits
      ) {
        return false;
      }

      // Filter by Status
      if (filters.filterByStatus && order.status !== filters.filterByStatus) {
        return false;
      }

      // Filter by Assigned To
      if (
        filters.filterByAssignedTo &&
        order.workOrderInformation.assignTo !== filters.filterByAssignedTo
      ) {
        return false;
      }

      // Filter by Vendor
      if (
        filters.filterByVendor &&
        order.workOrderInformation.vendorId !== filters.filterByVendor
      ) {
        return false;
      }

      // Filter by Unassigned
      if (filters.filterByUnassigned && order.workOrderInformation.assignTo) {
        return false;
      }

      //Filter by Work Order Type
      if (
        filters.filterByWorkOrderType &&
        order.ownerInformation.workOrderType !== filters.filterByWorkOrderType
      ) {
        return false;
      }

      //Filter by Resident
      // if (
      //   filters.searchByResident &&
      //   order.resident !== filters.searchByResident
      // ) {
      //   return false;
      // }

      //Filter by Description:
      if (
        filters.searchByDescription &&
        !order.ownerInformation.description.includes(
          filters.searchByDescription
        )
      ) {
        return false;
      }

      //Filter by Vendor Trade:
      if (
        filters.searchByVendorTrade &&
        order.vendorTrade !== filters.searchByVendorTrade
      ) {
        return false;
      }

      // Assuming creationDate exists in your workOrder data and is in the format YYYY-MM-DD
      // if (filters.dateRangeStart || filters.dateRangeEnd) {
      //   const orderDate = new Date(order.workOrderInformation.creationDate);
      //   if (
      //     filters.dateRangeStart &&
      //     orderDate < new Date(filters.dateRangeStart)
      //   ) {
      //     return false;
      //   }
      //   if (
      //     filters.dateRangeEnd &&
      //     orderDate > new Date(filters.dateRangeEnd)
      //   ) {
      //     return false;
      //   }
      // }

      //Filter by Billed:
      // if (
      //   filters.filterByBilled &&
      //   order.billedStatus !== filters.filterByBilled
      // ) {
      //   return false;
      // }

      //Filter by Priority:
      if (
        filters.filterByPriority &&
        order.ownerInformation.priority !== filters.filterByPriority
      ) {
        return false;
      }

      //Filter by Last Action (Number of Days Inactive):
      // if (filters.searchByLastAction) {
      //   const today = new Date();
      //   const lastActionDate = new Date(order.lastActionDate);
      //   const differenceInDays =
      //     (today - lastActionDate) / (1000 * 60 * 60 * 24);
      //   if (differenceInDays < filters.searchByLastAction) {
      //     return false;
      //   }
      // }

      //Filter by Work Order Number:
      // if (
      //   filters.searchByWorkOrderNumber &&
      //   order.id !== filters.searchByWorkOrderNumber
      // ) {
      //   return false;
      // }

      // ... include other filter conditions here ...

      return true; // if all conditions pass
    });

    setFilteredWorkOrders(filteredData);
  }, [filters,workOrders]);

  const mappedData = filteredWorkOrders?.map((item, index) => ({
    id: item.id,
    key: index,
    serviceRequest: (
      <span className="serviceRequestStatus" style={{ padding: "5px" }}>
        {item.status || "pending"}
      </span>
    ),
    Property: (
      <div>
        <span style={{ fontWeight: "bold" }}>{item.propertyName || ""}</span>
        <br />
        {/* <span>{item.propertyManager || ""}</span> */}
      </div>
    ),
    description:
      item.ownerInformation && item.ownerInformation.description
        ? item.ownerInformation.description
        : "",
    venderAndAssign: (
      <div>
        <span style={{ color: "gray" }}>Vendor/Assign</span>
        <br />
        <span>
          <i
            className="fa fa-user-circle"
            aria-hidden="true"
            style={{ fontSize: "20px" }}
          ></i>{" "}
          {item.vendorName || ""}
        </span>
      </div>
    ),
    createdAt: (
      <div>
        <span style={{ color: "gray" }}>Created</span>
        <br />
        {/* <span>
          {item.workOrderInformation && item.workOrderInformation.creationDate
            ? item.workOrderInformation.creationDate
            : "N/A"}
        </span> */}
      </div>
    ),
  }));

  return (
    <div className="workOrders">
      <div>
        <div className="pageheading">
          <h1>Work Orders</h1>
          <div className="pageHeadingBtns">
            <a href="/maintenance/work-orders/customize">Customize</a>
            <button onClick={handleNewServiceRequest}>
              {" "}
              <i aria-hidden="true" className="fa fa-plus-circle"></i> New
              Service Request
            </button>
          </div>
        </div>

        <div className="workOrderStatistics">
          <Row>
            <Col span={6}>
              <div className="workOrderStatisticsCards">
                <h3>0</h3>
                <a href="?UnassignedResidentRequested">
                  Unassigned Resident Requested
                </a>
              </div>
            </Col>
            <Col span={6}>
              <div className="workOrderStatisticsCards">
                <h3>0</h3>
                <a href="?UnassignedInternal">Unassigned Internal</a>
              </div>
            </Col>
            <Col span={6}>
              {" "}
              <div className="workOrderStatisticsCards">
                <h3>0</h3>
                <a href="?residentRequested">
                  Resident Requested Without Action In 2 Or More Days
                </a>
              </div>
            </Col>
            <Col span={6}>
              {" "}
              <div className="workOrderStatisticsCards">
                <h3>0</h3>
                <a href="?UnassignedResidentRequested">
                  Internal Without Action In 7 Or More Days
                </a>
              </div>
            </Col>
          </Row>
        </div>
        {/* <form action="">
          <Row justify="space-between">
            <Col span={5} className="searchByTradeFilter">
              <label
                htmlFor="searchByPropertiesUnits"
                className="labelForVendorInputs"
              >
                Properties or Units
              </label>
              <Select
                options={properties}
                placeholder="Search by Unit, Property or Property Group"
                //name="searchByPropertiesUnits"
                //  onChange={handleChangeInputs}
              />
            </Col>

            <Col span={5} className="searchByTradeFilter">
              <label htmlFor="filterByStatus" className="labelForVendorInputs">
                Status
              </label>

              <Select
                showSearch
                allowClear={""}
                placeholder="Filter by Status"
                // onChange={handleSearchByTrade}
                // onSearch={handleSearchByTrade}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={statusList}
                name="filterByStatus"
                defaultValue={statusList[1]}
                onChange={(filterByStatus) =>
                  handleChangeInputs({
                    name: "filterByStatus",
                    value: filterByStatus,
                  })
                }
                value={filtersData.filterByStatus}
              />
            </Col>

            <Col span={5} className="searchByTradeFilter">
              <label
                htmlFor="filterByAssignedTo"
                className="labelForVendorInputs"
              >
                Assigned To
              </label>
              <Select
                showSearch
                // allowClear={handleSearchByTrade}
                placeholder="Select..."
                // onChange={handleSearchByTrade}
                // onSearch={handleSearchByTrade}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={assignedToList}
                name="filterByAssignedTo"
                onChange={(assignedToList) =>
                  handleChangeInputs({
                    name: "assignedToList",
                    value: assignedToList,
                  })
                }
                value={filtersData.assignedToList}
              />
            </Col>

            <Col span={5} className="searchByTradeFilter">
              <label htmlFor="filterByVendor" className="labelForVendorInputs">
                Vendor
              </label>

              <Select
                showSearch
                // allowClear={handleSearchByTrade}
                placeholder="Search by vendor or management company"
                options={vendors}
                // name="filterByVendor"
                // value={filtersData.filterByVendor}
              />
            </Col>
          </Row>
          {isShowAdvancedFilters && (
            <>
              <br />

              <Row>
                <Col span={2}>
                  <label
                    htmlFor="filterByUnassigned"
                    className="labelForVendorInputs"
                  >
                    Unassigned
                  </label>

                  <Checkbox
                    name="filterByUnassigned"
                    onChange={(filterByUnassigned) =>
                      handleChangeInputs({
                        name: "filterByUnassigned",
                        value: filterByUnassigned,
                      })
                    }
                  />
                </Col>
                <Col span={5} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="searchByWorkOrderType"
                    className="labelForVendorInputs"
                  >
                    Work Order Type
                  </label>
                  <MultiSelect
                    options={propertyUnits}
                    placeholder="Select..."
                    onChange={(searchByWorkOrderType) =>
                      handleChangeInputs({
                        name: "searchByWorkOrderType",
                        value: searchByWorkOrderType,
                      })
                    }
                    value={filtersData.filterByWorkOrderType}
                  />
                </Col>
                <Col span={4} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="searchByResident"
                    className="labelForVendorInputs"
                  >
                    Resident
                  </label>
                  <Select
                    showSearch
                    // allowClear={handleSearchByTrade}
                    placeholder="Search by Resident"
                    // onChange={handleSearchByTrade}
                    // onSearch={handleSearchByTrade}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={venderList}
                    name="searchByResident"
                    onChange={(searchByResident) =>
                      handleChangeInputs({
                        name: "searchByResident",
                        value: searchByResident,
                      })
                    }
                    value={filtersData.searchByResident}
                  />
                </Col>
                <Col span={5} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="searchByDescription"
                    className="labelForVendorInputs"
                  >
                    Description
                  </label>
                  <Input
                    placeholder="Search within work order description"
                    name="searchByDescription"
                    onChange={handleSearchDescription}
                    value={filtersData.searchByDescription}
                  />
                </Col>
                <Col span={4} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="searchByVendorTrade"
                    className="labelForVendorInputs"
                  >
                    Vendor Trade
                  </label>
                  <Select
                    showSearch
                    // allowClear={handleSearchByTrade}
                    placeholder="Search by vendor or management company"
                    // onChange={handleSearchByTrade}
                    // onSearch={handleSearchByTrade}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={venderList}
                    name="searchByVendorTrade"
                    onChange={(searchByVendorTrade) =>
                      handleChangeInputs({
                        name: "searchByVendorTrade",
                        value: searchByVendorTrade,
                      })
                    }
                    value={filtersData.searchByVendorTrade}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={6}>
                  <Row>
                    <Col span={24}>
                      <label className="labelForVendorInputs">Date Range</label>
                      <br />
                      <Select
                        showSearch
                        // allowClear={handleSearchByTrade}
                        placeholder="select..."
                        // onChange={handleSearchByTrade}
                        // onSearch={handleSearchByTrade}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={venderList}
                        name="dateRangeFor"
                        style={{ width: "100%" }}
                        onChange={(dateRangeFor) =>
                          handleChangeInputs({
                            name: "dateRangeFor",
                            value: dateRangeFor,
                          })
                        }
                        value={filtersData.dateRangeFor}
                      />
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col span={11}>
                      <DatePicker
                        placeholder="start date"
                        name="dateRangeStart"
                        onChange={(dateRangeStart) =>
                          handleChangeInputs({
                            name: "dateRangeStart",
                            value: dateRangeStart,
                          })
                        }
                        value={filtersData.dateRangeStart}
                      />
                    </Col>
                    <Col span={2}>
                      <p style={{ textAlign: "center" }}>to</p>
                    </Col>
                    <Col span={11}>
                      <DatePicker
                        placeholder="end date"
                        name="dateRangeEnd"
                        onChange={(dateRangeEnd) =>
                          handleChangeInputs({
                            name: "dateRangeEnd",
                            value: dateRangeEnd,
                          })
                        }
                        value={filtersData.dateRangeEnd}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={2} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="filterByBilled"
                    className="labelForVendorInputs"
                  >
                    Billed
                  </label>
                  <Select
                    showSearch
                    // allowClear={handleSearchByTrade}
                    placeholder="Select.."
                    // onChange={handleSearchByTrade}
                    // onSearch={handleSearchByTrade}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "All",
                        label: "All",
                      },
                      {
                        value: "Billed",
                        label: "Billed",
                      },
                      {
                        value: "Unbilled",
                        label: "Unbilled",
                      },
                    ]}
                    name="filterByBilled"
                    onChange={(filterByBilled) =>
                      handleChangeInputs({
                        name: "filterByBilled",
                        value: filterByBilled,
                      })
                    }
                    value={filtersData.filterByBilled}
                  />
                </Col>
                <Col span={2} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="filterByPriority"
                    className="labelForVendorInputs"
                  >
                    Priority
                  </label>
                  <Select
                    showSearch
                    // allowClear={handleSearchByTrade}
                    placeholder="Select.."
                    // onChange={handleSearchByTrade}
                    // onSearch={handleSearchByTrade}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "All",
                        label: "All",
                      },
                      {
                        value: "Billed",
                        label: "Billed",
                      },
                      {
                        value: "Unbilled",
                        label: "Unbilled",
                      },
                    ]}
                    name="filterByPriority"
                    onChange={(filterByPriority) =>
                      handleChangeInputs({
                        name: "filterByPriority",
                        value: filterByPriority,
                      })
                    }
                    value={filtersData.filterByPriority}
                  />
                </Col>

                <Col span={5} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="searchByLastAction"
                    className="labelForVendorInputs"
                  >
                    Last Action
                  </label>
                  <Input
                    placeholder="number of days inactive"
                    name="searchByLastAction"
                    onChange={handleSearchByAction}
                    value={filtersData.searchByLastAction}
                    type="number"
                  />
                  <label
                    htmlFor="searchByResident"
                    className="labelForVendorInputs"
                    style={{ textAlign: "right" }}
                  >
                    or more days ago
                  </label>
                </Col>
                <Col span={5} className="searchByTradeFilter" offset={1}>
                  <label
                    htmlFor="searchByWorkOrderNumber"
                    className="labelForVendorInputs"
                  >
                    Work Order Number
                  </label>
                  <Select
                    showSearch
                    // allowClear={handleSearchByTrade}
                    placeholder="Search by Resident"
                    // onSearch={handleSearchByTrade}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={venderList}
                    name="searchByWorkOrderNumber"
                    onChange={(searchByWorkOrderNumber) =>
                      handleChangeInputs({
                        name: "searchByWorkOrderNumber",
                        value: searchByWorkOrderNumber,
                      })
                    }
                    value={filtersData.searchByWorkOrderNumber}
                  />
                </Col>
              </Row>
            </>
          )}

          <div className="workOrderSearchFiltersBtns">
            <Row>
              <Col span={4}>
                <a onClick={handleAdvancedFilters}>
                  {isShowAdvancedFilters ? "Hide" : "Show"} Advanced Filters
                </a>
              </Col>
              <Col span={4}>
                <a onClick={handleResetInputs}>Reset Filters</a>
              </Col>
            </Row>
          </div>
        </form> */}
        <br />

        <Table
          rowSelection={rowSelection}
          columns={tableTopHeader}
          dataSource={mappedData}
          loading={isLoading}
          expandable={{
            expandedRowRender: (record) => {
              console.log("Expanding row with record:", record);
              return (
                <div>
                  <Row>
                    <Col offset={4}>
                      <Button type="link">View</Button>
                    </Col>
                    <Col>
                      <Button type="link">Quick Edit</Button>
                    </Col>
                    <Col>
                      <Button type="link">Mark Job Done</Button>
                    </Col>
                    <Col>
                      <Button type="link">Email</Button>
                    </Col>
                    <Col>
                      <Button type="link">
                        <span className="red-text">Cancel</span>
                      </Button>
                    </Col>
                  </Row>
                </div>
              );
            },
            expandIcon: () => <></>,
          }}
          expandedRowKeys={[expended]}
          footer={false}
          onRow={(record) => {
            return {
              onClick: () =>
                navigate(`/maintenance/work-orders/work-order/${record.id}`),
            };
          }}
        />
      </div>

      <div className="RightSidebar">
        <RightBar RightBarData={WorkOrdersRightBar} />
      </div>
    </div>
  );
}

export default WorkOrders;
